// Safe formatters for property price / area. Never throws on null/0/NaN.
// Rule: treat 0, null, undefined, "", non-finite numbers as "missing".

const CURRENCY_SYMBOL = {
  TRY: "₺",
  EUR: "€",
  USD: "$",
  GBP: "£",
};

export function isValidNumber(v) {
  if (v === null || v === undefined || v === "") return false;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) && n > 0;
}

export function getBestPrice(prop) {
  // Prefer current_price if it's a real number, else fall back to legacy price.
  if (isValidNumber(prop?.current_price)) return Number(prop.current_price);
  if (isValidNumber(prop?.price)) return Number(prop.price);
  return null;
}

export function getBestArea(prop) {
  if (isValidNumber(prop?.net_area)) return Number(prop.net_area);
  if (isValidNumber(prop?.area)) return Number(prop.area);
  return null;
}

export function getCurrencyLabel(prop) {
  const c = prop?.currency || "TRY";
  if (c === "Diğer") return prop?.currency_other || "";
  return CURRENCY_SYMBOL[c] || c;
}

/** Format a price. Returns "Fiyat girilmedi" when missing. */
export function formatPrice(prop, opts = {}) {
  const { fallback = "Fiyat girilmedi" } = opts;
  const p = getBestPrice(prop);
  if (p == null) return fallback;
  const label = getCurrencyLabel(prop);
  try {
    return `${p.toLocaleString("tr-TR")} ${label}`.trim();
  } catch {
    return `${p} ${label}`.trim();
  }
}

/** Format price/m². Returns null when either price or area is missing. */
export function formatPricePerM2(prop) {
  const p = getBestPrice(prop);
  const a = getBestArea(prop);
  if (p == null || a == null) return null;
  const label = getCurrencyLabel(prop);
  try {
    return `${Math.round(p / a).toLocaleString("tr-TR")} ${label}/m²`.trim();
  } catch {
    return `${Math.round(p / a)} ${label}/m²`.trim();
  }
}

/** True when neither price nor area is valid. */
export function hasNoPricing(prop) {
  return getBestPrice(prop) == null && getBestArea(prop) == null;
}
